import * as Yup from 'yup';
import apiAddress from '../local-config';

export const config = {
  url: {
    API_URL: apiAddress.apiAddress,
    WIN_AUTH_URL: apiAddress.winAuthAddress,
  },
  version: apiAddress.version,
};
// TODO Should be reviewed
export const protectedRoutes = ['/favorites', '/mylots', '/profile', '/create', '/edit'];

export const nameRegExp = new RegExp(/^[a-zA-ZА-ЯҐЄІЇа-яєії,.'-/s ]+$/);

export const passwordRegExp = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])((?=.*?\W)|(?=.*?[_])).{6,20}$/);

export const phoneRegExp = new RegExp(/^\s*\+?\s*([0-9][\s-]*){9,}$/);

export const addressRegEx = new RegExp(/^[a-zA-ZА-ЯҐЄІЇа-яєії,.'-/s ]+$/);

export const maxFileNumber = 7;
export const maxFileSize = 2097152;

export const lotsPerPage = 24;
export const pagesBeforeReduction = 1;
export const lotsPerPageArr = [12, 24, 48, 96];

export const charityBannerCategoryId = 14;

export const INTERVAL_UPDATE_TOKEN = 20 * 60 * 1000; // 20 min

// Currently BE get Azure Token with 30 min expiration period
export const LOCAL_TOKEN_EXPIRATION_INTERVAL = 29;

export const LOTS_VIEW_BY_FILTER = {
  DATE: 'DATE',
  PRICE: 'PRICE',
};

export const ROLE_CLAIM_IDENTIFIER = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

export const BNS3_OTHER_LOT_CATEGORY_ID = 13;
export const BNS3_CHARITY_LOT_CATEGORY_ID = 14;
export const BNS3_MAX_TITLE_LENGTH = 90;
export const BNS3_SERVICE_PRODUCT_TYPE = 'Service';
export const BNS3_ALL_CATEGORY = { value: '0', label: 'All' };
export const BNS3_MAX_AMOUNT_OF_LOT_TAGS = 11;

// Filter constants
export const lotTypes = [
  { label: 'All', value: 'all' },
  { label: "I'm Looking For", value: 'lookingFor' },
  { label: 'I Offer', value: 'offer' },
];

export const productTypes = [
  {
    value: 'all',
    label: 'All lots',
  },
  {
    value: 'goods',
    label: 'Goods',
    children: [
      {
        value: 'new',
        label: 'New',
      },
      {
        value: 'used',
        label: 'Used',
      },
    ],
  },
  {
    value: 'service',
    label: 'Service',
    children: [],
  },
];

export const sortingTypeNames = {
  isNewest: 'isNewest',
  isOldest: 'isOldest',
  isMostCheap: 'isMostCheap',
  isMostExpensive: 'isMostExpensive',
};

 export const PAGE_INACTIVE_RELOAD_THRESHOLD_MS = 100 * 1000;

export const TOKEN_KEY = 'token';
export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';
export const LOGIN_STATUS_KEY = 'loginUserStatus';
export const USER_KEY = 'user';
export const LOGGING_OUT_VALUE = 'LOGGING-OUT';
export const DEFAULT_CURRENCY = 'USD';

export const DROPDOWN_TYPE = {
  VALUE_STORE: {
    ABSOLUTE: 'ABSOLUTE',
    RELATIVE: 'RELATIVE',
  },
  ITEM_QUANTITY: {
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE',
  },
};

export const SearchParams = [
  {
    name: 'searchInDescription',
    value: 'Find also in descriptions',
    query: 'searchInDescription=true',
  },
  {
    name: 'useFullTextSearch',
    value: 'Enable full-text',
    query: 'useFullTextSearch=true',
  },
  // Hided in v3.5. This functionality will be restored later
  // {
  //   name: 'freezedLots',
  //   value: 'Show also freezed lots',
  //   query: 'freezedLots=true',
  // },
  // {
  //   name: 'searchInFrendlyLots',
  //   value: 'Friendly support lots',
  //   query: 'searchInFrendlyLots=true',
  // },
];

export const MY_LOTS_PAGE = { href: '/mylots', title: 'My Lots', filterParam: { createdByUser: true } };
export const MY_SUBSCRIPTIONS_PAGE = { href: '/mySubscriptions', title: 'My Subscriptions' };
export const NEW_SUBSCRIPTION_PAGE = { href: '/newSubscription', title: 'New Subscriptions' };
export const FAVORITE_LOTS_PAGE = { href: '/favorites', title: 'My Favorites', filterParam: { isFavorited: true } };
export const MY_CHARITY_BANNERS_PAGE = {
  href: '/myCharityBanners',
  title: 'My Charity Banners',
  filterParam: { createdByUser: true },
};
export const ADMIN_PAGE = { href: '/admin', title: 'Admin Panel' };

export const MENU_ITEMS = [
  { children: 'My Profile', link: '/profile' },
  { children: MY_LOTS_PAGE.title, link: MY_LOTS_PAGE.href },
  { children: MY_SUBSCRIPTIONS_PAGE.title, link: MY_SUBSCRIPTIONS_PAGE.href },
  {
    children: MY_CHARITY_BANNERS_PAGE.title,
    link: MY_CHARITY_BANNERS_PAGE.href,
    menuItemProps: {
      divider: true,
    },
  },
  // Hided in v3.5. This functionality will be restored later
  // { title: 'My Charity', link: '/myCharityLots' },
  // { title: 'Settings', link: '/' },
];

export const MAX_PRICE = 9999999;
export const DIGIT_REGEXP = /^\d*([.,]\d{0,2})?$/;

export const ModalsList = {
  LimitationLiabilityModal: {
    name: 'LimitationLiabilityModal',
  },
  CancelationModal: {
    name: 'CancelationModal',
    text: 'All changes will be deleted',
  },
  DeleteModal: {
    name: 'DeleteModal',
    text: 'The lot will be deleted without the possibility of restoring it',
  },
  CancelSubscriptionModal: {
    name: 'CancelSubscriptionModal',
    text: 'This subscription will be canceled.',
  },
};

export const RequiredFieldString = 'This field is required';
export const ONLY_SPECIAL_SYMBOLS_ERROR = 'The name cannot contain only special symbols. Please, enter a valid name.';
export const MAX_MESSAGE_LENGTH = 2000;
export const MAX_LENGTH = `The length of your message should not exceed ${MAX_MESSAGE_LENGTH} characters.`;

export const MIN_DESCRIPTION_LENGTH = 20;
export const MAX_DESCRIPTION_LENGTH = 9000;
export const DESCRIPTION_LENGTH_STRING = `Description length must be between ${MIN_DESCRIPTION_LENGTH} and ${MAX_DESCRIPTION_LENGTH} symbols. HTML tags are not allowed.`;

export const LotFormBaseRules = {
  lotType: Yup.string(),

  lotState: Yup.number(),

  productType: Yup.string(),

  categoryId: Yup.number(),

  subcategoryId: Yup.number().when('categoryId', {
    is: (id: number) => id === BNS3_CHARITY_LOT_CATEGORY_ID,
    then: () => Yup.number().nullable(),
    otherwise: () => Yup.number().required(RequiredFieldString),
  }),

  title: Yup.string()
    .transform(val => (val === '' ? undefined : val))
    .min(2, "The length of 'Title' must be at least 2 characters.")
    .max(BNS3_MAX_TITLE_LENGTH, `The length of 'Title' must be ${BNS3_MAX_TITLE_LENGTH} characters or fewer.`)
    .test('is-not-number', 'Title must contain at least 2 non-numeric characters', val =>
      val ? /^(?=(?:.*[^\d\s]){2,})[^]*$/.test(val) : true
    )
    .test('not-only-special-symbols', ONLY_SPECIAL_SYMBOLS_ERROR, val =>
      val ? /[a-zA-ZА-ЯҐЄІЇа-яєії]/.test(val.trim()) : true
    ),

  locationId: Yup.number(),

  fixedPrice: Yup.number().when('categoryId', {
    is: (id: number) => id === BNS3_CHARITY_LOT_CATEGORY_ID,
    then: () => Yup.number().nullable(),
    otherwise: () =>
      Yup.number()
        .transform((value, originalValue) => {
          return originalValue === '' || originalValue === null ? undefined : value;
        })
        .required(RequiredFieldString)
        .test(
          'not-zero',
          "The Lot Price must be greater than 0. To list this lot as free, select 'For Free' from the Category dropdown.",
          value => value === undefined || value > 0
        )
        .test('max-2-decimals', 'Price can have at most 2 decimal places', value =>
          value === undefined ? true : /^\d+(\.\d{1,2})?$/.test(String(value).replace(',', '.'))
        )
        .max(MAX_PRICE, `Price should be ${MAX_PRICE} or less`),
  }),

  tagIds: Yup.array().transform(arr => (arr?.length ? arr : undefined)),
  description: Yup.string()
    .transform(val => (val === '' ? undefined : val))
    .min(MIN_DESCRIPTION_LENGTH, DESCRIPTION_LENGTH_STRING)
    .max(MAX_DESCRIPTION_LENGTH, DESCRIPTION_LENGTH_STRING),
};

export const LotDraftFormSchema = Yup.object({
  lotType: LotFormBaseRules.lotType.notRequired(),
  lotState: LotFormBaseRules.lotState.notRequired(),
  productType: LotFormBaseRules.productType.notRequired(),
  categoryId: LotFormBaseRules.categoryId.notRequired(),
  subcategoryId: Yup.number().nullable(),
  title: LotFormBaseRules.title.required(RequiredFieldString),
  locationId: LotFormBaseRules.locationId.notRequired(),
  fixedPrice: Yup.number().when('categoryId', {
    is: (id: number) => id === BNS3_CHARITY_LOT_CATEGORY_ID,
    then: () => Yup.number().nullable(),
    otherwise: () =>
      Yup.number()
        .transform((value, originalValue) => {
          return originalValue === '' || originalValue === null ? undefined : value;
        })
        .test(
          'not-zero',
          "The Lot Price must be greater than 0. To list this lot as free, select 'For Free' from the Category dropdown.",
          value => value === undefined || value > 0
        )
        .test('max-2-decimals', 'Price can have at most 2 decimal places', value =>
          value === undefined ? true : /^\d+(\.\d{1,2})?$/.test(String(value).replace(',', '.'))
        )
        .max(MAX_PRICE, `Price should be ${MAX_PRICE} or less`),
  }),
  tagIds: LotFormBaseRules.tagIds.notRequired(),
  description: LotFormBaseRules.description.notRequired(),
});

export const LotFormSchema = Yup.object({
  lotType: LotFormBaseRules.lotType.required(RequiredFieldString),
  lotState: LotFormBaseRules.lotState.required(RequiredFieldString),
  productType: LotFormBaseRules.productType.required(RequiredFieldString),
  categoryId: LotFormBaseRules.categoryId.required(RequiredFieldString),
  subcategoryId: LotFormBaseRules.subcategoryId,
  title: LotFormBaseRules.title.required(RequiredFieldString),
  locationId: LotFormBaseRules.locationId.required(RequiredFieldString),
  fixedPrice: LotFormBaseRules.fixedPrice,
  tagIds: LotFormBaseRules.tagIds.required(RequiredFieldString),
  description: LotFormBaseRules.description.required(RequiredFieldString),
});

export const MAX_SEARCH_QUERY_LENGTH = 200;



export const IMAGE_TYPES = {
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PNG: 'image/png',
};

export const LOT_STATUS = {
  DEACTIVATED: 'Deactivated',
  DELETED: 'Deleted',
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
};
